import React, { useEffect, useState } from 'react';
import './Contacts.css';
import { fetchData } from '../../config/dataService';

export default function Contacts() {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  // Form state
  const [form, setForm]       = useState({ name: '', email: '', checkin: '', checkout: '', message: '' });
  const [sending, setSending] = useState(false);
  const [sent, setSent]       = useState(false);

  useEffect(() => {
    fetchData('contacts')
      .then(setData)
      .catch(setError)
      .finally(() => setLoading(false));
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    // Replace this with your actual form submission logic (e.g. SES, Formspree, etc.)
    await new Promise(r => setTimeout(r, 1200));
    setSending(false);
    setSent(true);
  };

  if (loading) return <div className="loading-state">Loading contact info…</div>;
  if (error)   return <div className="error-state">Could not load contact info. Please try again.</div>;

  const { title = 'Contact Us', subtitle, contactInfo = [], form: formConfig = {} } = data || {};

  return (
    <main className="contacts">
      <div className="container">
        <div className="contacts__header">
          <h1 className="section-title">{title}</h1>
          {subtitle && <p className="section-subtitle">{subtitle}</p>}
          <div className="divider" />
        </div>

        <div className="contacts__layout">
          {/* Info cards */}
          <div className="contacts__info">
            {contactInfo.map((item, i) => (
              <div key={i} className="contacts__info-card fade-up" style={{ animationDelay: `${i * 0.1}s` }}>
                <div className="contacts__info-icon">{item.icon}</div>
                <div>
                  <div className="contacts__info-label">{item.label}</div>
                  <div className="contacts__info-value">
                    {item.value.split('\n').map((line, j, arr) => (
                      <React.Fragment key={j}>
                        {line}
                        {j < arr.length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Enquiry form */}
          <div className="contacts__form-wrap fade-up" style={{ animationDelay: '0.2s' }}>
            <h2 className="contacts__form-title">
              {formConfig.title || 'Send an Enquiry'}
            </h2>

            {sent ? (
              <div className="contacts__success">
                ✓ Thank you! Your message has been sent. We'll be in touch shortly.
              </div>
            ) : (
              <form className="contacts__form" onSubmit={handleSubmit} noValidate>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Your Name</label>
                    <input
                      id="name" name="name" type="text"
                      value={form.name} onChange={handleChange}
                      placeholder="Jane Smith" required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address</label>
                    <input
                      id="email" name="email" type="email"
                      value={form.email} onChange={handleChange}
                      placeholder="jane@example.com" required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="checkin">Check-in Date</label>
                    <input
                      id="checkin" name="checkin" type="date"
                      value={form.checkin} onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="checkout">Check-out Date</label>
                    <input
                      id="checkout" name="checkout" type="date"
                      value={form.checkout} onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message" name="message"
                    value={form.message} onChange={handleChange}
                    placeholder={formConfig.messagePlaceholder || 'Tell us about your stay requirements…'}
                    required
                  />
                </div>

                <button type="submit" className="contacts__submit" disabled={sending}>
                  {sending ? 'Sending…' : (formConfig.submitLabel || 'Send Enquiry')}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
